import { render, staticRenderFns } from "./AssessmentSection5.vue?vue&type=template&id=036ed44c&scoped=true&"
import script from "./AssessmentSection5.vue?vue&type=script&lang=ts&"
export * from "./AssessmentSection5.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentSection5.vue?vue&type=style&index=0&id=036ed44c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ed44c",
  null
  
)

export default component.exports